import { AuthTokens } from '../authTypes';

export class TokenManager {
  private refreshTimer: NodeJS.Timeout | null = null;

  startAutoRefresh(
    tokens: AuthTokens,
    refreshCallback: () => Promise<void>,
  ): void {
    this.stopAutoRefresh();

    // Refresh 5 minutes before expiration
    const refreshTime = tokens.expires_at - Date.now() - 5 * 60 * 1000;

    if (refreshTime > 0) {
      this.refreshTimer = setTimeout(async () => {
        try {
          await refreshCallback();
        } catch {
          // Auto refresh failed - will be handled by the auth service
        }
      }, refreshTime);
    }
  }

  stopAutoRefresh(): void {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
  }
}
